/**
 * Calendar Event Card Component
 * Displays calendar event entity information from MCP tool results
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarOutlined } from '@ant-design/icons';
import { useUserTimezone } from '@/hooks/useUserTimezone';
import type { CalendarEventEntity } from '@/api/types/mcp.types';
import './EntityCard.css';

interface CalendarEventCardProps {
  event: CalendarEventEntity;
  compact?: boolean;
}

export const CalendarEventCard: React.FC<CalendarEventCardProps> = ({
  event,
  compact = false,
}) => {
  const { formatDateTime } = useUserTimezone();

  return (
    <div
      className={`calendar-event-card entity-card ${compact ? 'compact' : ''}`}
    >
      <div className="entity-card-header">
        <h4 className="entity-card-title">
          <CalendarOutlined style={{ marginRight: 8 }} />
          {event.title}
        </h4>
      </div>

      {!compact && (
        <div className="entity-card-body">
          {event.start_date && (
            <div className="entity-card-field">
              <span className="field-label">Start:</span>
              <span className="field-value">
                {formatDateTime(event.start_date, 'MMM D, hh:mm A')}
              </span>
            </div>
          )}
          {event.end_date && (
            <div className="entity-card-field">
              <span className="field-label">End:</span>
              <span className="field-value">
                {formatDateTime(event.end_date, 'MMM D, hh:mm A')}
              </span>
            </div>
          )}
        </div>
      )}

      <div className="entity-card-footer">
        <Link to={`/apps/calendar/${event.id}`} className="entity-card-link">
          View Event →
        </Link>
      </div>
    </div>
  );
};
